<template>
    <div>
        <fl44-contract-supplementary-agreement-termination-limits-editable-table
            v-if="limitsRequired"
            v-model="form.limits.items"
            :total-cost="supplementaryAgreement.price"
            @validate="limitsValidate"
            :limit-year="purchase.purchase_limit_year"
            :order-type="purchase.order_type"
            purchase-type="fl44"
            :purchase-id="purchase.id">
            <template #title>
                <h5 class="grey-color ml-1 mt-3 mb-1 main_text font-weight-bold">Измените лимиты</h5>
            </template>
            <template #label-hint> Добавьте или измените лимиты. Необходимо полностью распределить стоимость дополнительного соглашения по соответствующим лимитам. </template>
            <template #label-total> Стоимость дополнительного соглашения, руб.: </template>
            <template #label-variance> Отклонение от стоимости дополнительного соглашения, руб.: </template>
        </fl44-contract-supplementary-agreement-termination-limits-editable-table>
        <form-row-edit-supplier-accounting v-if="limitsRequired" v-model="form.supplier_accounting" @validate="supplierAccountingValidate">
            <template #title>
                <h5 class="ml-1 mt-3 mb-1 main_text font-weight-bold">Банковские реквизиты поставщика</h5>
            </template>
            <template #info>
                <div class="ml-1 fs-14">Укажите банковские реквизиты поставщика для заключения контракта, которые будут переданы в РИС после заключения.</div>
            </template>
        </form-row-edit-supplier-accounting>
        <fl44-contract-customer-sign-supplementary-agreement-button class="mb-2" :purchase="purchase" :is-available="!$v.$invalid" :form="form" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" />
        <p v-if="supplementaryAgreement.type.id === 'termination'" class="font-weight-bold text-danger mt-2 mb-1 fs-14">Внимание! Для данной закупки будут заблокированы функции: изменение лимитов, добавление дополнительного соглашения, изменение статуса.</p>
    </div>
</template>

<script>
import { requiredIf } from 'vuelidate/lib/validators';

import Config from '@/rearchitected/core/js/ddriven/application/config/Config';
import cloneDeep from 'lodash.clonedeep';
import Fl44ContractCustomerSignSupplementaryAgreementButton from '@/components/products/fl44/partials/fl44-contract-customer-sign-supplementary-agreement-button.vue';
import FormRowEditSupplierAccounting from '@/components/common/form-rows/form-row-edit-supplier-accounting.vue';
import Fl44ContractSupplementaryAgreementTerminationLimitsEditableTable from '@/components/products/fl44/partials/fl44-contract-supplementary-agreement-termination-limits-editable-table.vue';

export default {
    name: 'private-fl44-contract-supplementary-agreement-sign-form-customer',
    components: { Fl44ContractSupplementaryAgreementTerminationLimitsEditableTable, FormRowEditSupplierAccounting, Fl44ContractCustomerSignSupplementaryAgreementButton },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        }
    },
    mounted() {
        this.form.limits.items = cloneDeep(this.supplementaryAgreement.limits);
        this.form.supplier_accounting = cloneDeep(this.supplementaryAgreement.supplier_accounting);
    },
    data() {
        return {
            isDataSending: false,
            form: {
                limits: {
                    items: []
                },
                supplier_accounting: {
                    bank_type: 'bank',
                    bik: null,
                    bank_name: null,
                    bank_city: null,
                    ks: null,
                    rs: null,
                    ls: null,
                    fo_inn: null,
                    fo_name: null
                }
            },
            isLimitsValid: false,
            isSupplierAccountingValid: false
        };
    },
    validations() {
        return {
            form: {
                limits: {
                    isLimitsValid() {
                        return !this.limitsRequired || this.isLimitsValid;
                    }
                },
                supplier_accounting: {
                    required: requiredIf(() => this.limitsRequired),
                    isSupplierAccountingValid() {
                        return !this.limitsRequired || this.isSupplierAccountingValid;
                    }
                }
            }
        };
    },
    methods: {
        limitsValidate(value) {
            this.isLimitsValid = !value;
        },
        supplierAccountingValidate(value) {
            this.isSupplierAccountingValid = !value;
        }
    },
    computed: {
        Config() {
            return Config;
        },
        limitsRequired() {
            return this.features.kbk_limits && !this.purchase.without_limits;
        },
        features() {
            return Config.get('theme.features');
        }
    }
};
</script>
